/* Sidebar variant only: a compact single-row hint for embedding in a controls
   column (the schedule generator), rather than the floating top-of-page pill.
   The floating variant now renders via the shared TopBanner primitive
   (TopBanner.module.css). The message truncates so the row stays one line in a
   narrow sidebar. */
.sidebarPill {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  background: var(--app-warning-soft);
  border-radius: var(--app-radius-lg);
  padding: 10px 14px;
  transition:
    transform var(--app-transition),
    box-shadow var(--app-transition);
  will-change: transform;
}

.sidebarPill:hover {
  transform: translateY(-1px);
  box-shadow: var(--app-shadow-sm);
}

.sidebarPill:active {
  transform: translateY(0);
}

/* "Change your personalization" state (already personalized): calmer surface so
   it reads as a settings link rather than a warning nudge. */
.sidebarPillNeutral {
  background: var(--app-surface-sunken);
}

.sidebarText {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (prefers-reduced-motion: reduce) {
  .sidebarPill {
    transition: box-shadow var(--app-transition);
  }

  .sidebarPill:hover {
    transform: none;
  }
}
